import { render, staticRenderFns } from "./ChatFeedbackReview.vue?vue&type=template&id=b1a00cb6&"
import script from "./ChatFeedbackReview.vue?vue&type=script&lang=ts&"
export * from "./ChatFeedbackReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports